import { call, put, takeLatest } from "redux-saga/effects";
import {
    AI_DESC_PD_GENERATE_DESC,
    AI_DESC_PD_HANDLE_ACTION_DESC,
    AI_DESC_PD_REGENERATE_DESC,
    AI_DESC_PD_SELECT_PROP_ADDRESS,
    fetchNearByAmmenities,
    fetchPdDesc,
    handlePdSeverBusyPopup,
    updateActionPdDesc,
    updatePropAdd,
} from "./PropertyDescriptionReducer";
import { httpRequest } from "../../../utils/networkCalls";
import { updateLoadingStatus } from "../../Loader/LoaderReducer";
import { scrollToTop, showToastMessage } from "../../../utils/common";
import { aiMhHandlePopupOpen } from "../AimhLandingPage/AimhLpReducer";
import history from "../../../utils/history";
import { PdFormat, checkActRes } from "./PropertyDescriptionUtils";

const nearbyAmenities= {
    "College/School": {
        isSelected: false,
    },
    Healthcare: {
        isSelected: false,
    },
    Hotel: {
        isSelected: false,
    },
    Supermarket: {
        isSelected: false,
    },
    "Bars/Nightclubs": {
        isSelected: false,
    },
    Theaters: {
        isSelected: false,
    },
    Kindergarten: {
        isSelected: false,
    },
    "Pet/Veterinary": {
        isSelected: false,
    },
    "Beauty/Saloon": {
        isSelected: false,
    },
    Sports: {
        isSelected: false,
    },
    "Gym/Fitness": {
        isSelected: false,
    },
    "Shopping malls": {
        isSelected: false,
    },
    "Gas station":{
        isSelected: false,
    },
}

const newNearbyAmenities = {
    school:{
        ammenities:{
            "College/School": {
                isSelected: false,
            },
            Healthcare: {
                isSelected: false,
            },
        }
    }
}

// let displayPropmt=""

// Generate description
export function* GenPropDesc(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        const res = yield call(
            httpRequest,
            "/ai-marketing-hub/generate-text",
            "post",
            action.payload.reqBody
        );

        // Set up format
        let resArr = [];
        if (res?.status === "success" && res?.data.length > 0) {
            resArr = PdFormat(res?.data);

            // Set Response in Reducer
            yield put(fetchPdDesc({descriptions:resArr}));
            scrollToTop()
        }else if(res?.status==="error" && res?.data==="Exhausted the free trial limit"){
            yield put(
                aiMhHandlePopupOpen({ type: "eftPopup", isVisible: true })
            );
            history.push("/ai-marketinghub")
        }else if(res?.status==="error" && res?.data){
            if(res.data==="Request failed with status code 429"){
                yield put(handlePdSeverBusyPopup({isShow:true}))
            }else{
                showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
            }
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }

        // Hide Loader here
        yield put(updateLoadingStatus(false));

    } catch (err) {
        throw err;
    }
}

// Regenerate description
export function* ReGenPropDesc(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        // const res = yield call(
        //     httpRequest,
        //     "/ai-marketing-hub/regenerate-text",
        //     "post",
        //     action.payload
        // );

        const res = yield call(
            httpRequest,
            "/ai-marketing-hub/rewrite-generations",
            "post",
            action.payload
        );

        // Set up format
        let resArr = [];
        if (res?.status === "success" && res?.data.length > 0) {
            resArr = PdFormat(res?.data);
            
            // Set Response in Reducer
            yield put(fetchPdDesc({descriptions:resArr}));
        }else if(res?.status==="error" && res?.data==="Exhausted the free trial limit"){
            yield put(
                aiMhHandlePopupOpen({ type: "eftPopup", isVisible: true })
            );
            history.push("/ai-marketinghub")
        }else if(res?.status==="error" && res?.data){
            showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }

        // Hide Loader here
        yield put(updateLoadingStatus(false));

    } catch (err) {
        throw err;
    }
}

// After Selecting Property Address Fecth Nearby Amenities
export function* handleSelectPropAdd(action) {
    try {
        // Call API
        const res = yield call(
            httpRequest,
            `ai-marketing-hub/get-near-by-amenities?lng=${action.payload.longitutde}&lat=${action.payload.latitutde}&radius=3000`,
            "get",
        );

        // Set Response in Reducer
        if(res.status==="success"){
            let ammenities={}
            res?.data.forEach((obj)=>{
                // ammenities[amm]={isSelected:res?.data[amm]}
                for (const key in obj) {
                    if(obj[key].length>0){
                        obj[key].forEach((ammObj,i)=>{
                            if(ammObj?.["properties"]?.["name"]){
                                if(!ammenities[key]){
                                    ammenities[key]={};
                                }
                                ammenities[key][ammObj?.["properties"]?.["name"]]={
                                    isSelected: false,
                                }
                            }
                        })
                    }
                }
            })
            yield put(updatePropAdd({ propAdd:action.payload.name }));
            yield put(fetchNearByAmmenities({ammenities}));

            // if(falsecheck){
            //     alert("Based upon your locality, we have found a few amenities within the radius of 5 miles.")
            // }else{
            //     alert("Based upon your locality, we could not find any amenities within the radius of 5 miles. Please select from the below available options")
            // }
        }else if(res?.status==="error" && res?.data){
            showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }
    } catch (err) {
        throw err;
    }
}

// Handle actions (like, dislike, save etc) description
export function* handleActionPropDesc(action) {
    try {

        // Call API
        const res = yield call(
            httpRequest,
            `/ai-marketing-hub/update-description/${action.payload.gen_id}`,
            "patch",
            action.payload.actionInfo
        );
        
        if(res?.status==="success"){
            // Check for response
            if (checkActRes(res, action)) {
                // Set Response in Reducer
                yield put(
                    updateActionPdDesc({
                        descInd: action.payload.descInd,
                        actionInfo: action.payload.actionInfo,
                        isEdited: res.data[action.payload.descInd].is_edited
                    })
                );
                if(action.payload.actionInfo.hasOwnProperty("like_status")){
                    showToastMessage({ icon: "success", mssge: "Thank you for your feed back!", time: 3000 });
                }else{
                    showToastMessage({ icon: "success", mssge: "Changes Saved", time: 3000 });
                }
            }else{
                showToastMessage({ icon: "error", mssge: "Changes could not be Saved", time: 3000 });
            }
        }else if(res?.status==="error" && res?.data){
            showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }
    } catch (err) {
        throw err;
    }
}

export function* sagaPropertyDesc(params) {
    // GenPropDesc gets called when AI_DESC_PD_GENERATE_DESC is dispatched
    yield takeLatest(AI_DESC_PD_GENERATE_DESC, GenPropDesc);
    yield takeLatest(AI_DESC_PD_REGENERATE_DESC, ReGenPropDesc);
    yield takeLatest(AI_DESC_PD_HANDLE_ACTION_DESC, handleActionPropDesc);
    yield takeLatest(AI_DESC_PD_SELECT_PROP_ADDRESS, handleSelectPropAdd);
}
